import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import { SystemConfig, UpdateSystemConfigBody, updateSystemConfigById } from '../../services/apiSLTP/systemConfig';

type UseUpdateSystemConfigMutationOptions = MutationOptions<
  SystemConfig,
  Error,
  { id: string; data: UpdateSystemConfigBody }
>;

export const useUpdateSystemConfigMutation = (options?: UseUpdateSystemConfigMutationOptions) => {
  const systemConfigMutation: MutationFunction<SystemConfig, { id: string; data: UpdateSystemConfigBody }> = async ({ id, data }) => {
    try {
      const response = await updateSystemConfigById(id, data);
      return response.data;
    } catch (error) {
      throw new Error('An unexpected error occurred during system config update');
    }
  };

  return useMutation(systemConfigMutation, options);
};
